module.exports = __webpack_public_path__ + "media/review-badges/rank-500-62d0d2eb.svg";